import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';
import { production } from 'src/app/Models/ApplicationModels';
import {
  ColorSchedule,
  ColorScheduleGenerate,
  ProductionCycle,
  ProductionCycleSchedule,
} from '../models/week-color.model';
import { get } from 'jquery';

@Injectable({
  providedIn: 'root',
})
export class WeekColorService {
  private readonly baseUrl = `${environment.productionSystemApiBaseUrl}ProductionCycle`;

  constructor(private http: HttpClient) {}

  // Production Cycle APIs
  addUpdateProductionCycle(productionCycle: ProductionCycle) {
    return this.http.post(`${this.baseUrl}`, productionCycle);
  }

  updateProductionCycleSortOrder(productionCycles: ProductionCycle[]) {
    return this.http.put(`${this.baseUrl}/sortorder`, productionCycles);
  }

  getProductionCycles(companyId: number) {
    return this.http.get(`${this.baseUrl}?CompanyId=${companyId}`);
  }
  getProductionCycleById(id: number) {
    return this.http.get(`${this.baseUrl}/${id}`);
  }
  deleteProductionCycle(ids: string) {
    return this.http.delete(`${this.baseUrl}/${ids}`);
  }
  updateProductionCycleStatus(ids: string) {
    return this.http.post(`${this.baseUrl}/Status?Ids=${ids}`, null);
  }

  // Production Cycle Schedule APIs
  getProductionCycleSchedule(companyId: number) {
    return this.http.get<ProductionCycleSchedule[]>(
      `${this.baseUrl}/Schedule/?CompanyId=${companyId}`,
    );
  }
  getPastProductionCycleSchedule(companyId: number) {
    return this.http.get<ProductionCycleSchedule[]>(
      `${this.baseUrl}/Schedule/Past/${companyId}`,
    );
  }

  previewProductionCycleSchedule(colorSchedule: ColorScheduleGenerate) {
    return this.http.post<ProductionCycleSchedule[]>(
      `${this.baseUrl}/Schedule/Preview`,
      colorSchedule,
    );
  }

  addProductionCycleSchedule(productionCycleSchedule: ColorScheduleGenerate) {
    return this.http.post<ProductionCycleSchedule[]>(
      `${this.baseUrl}/Schedule`,
      productionCycleSchedule,
    );
  }

getProductionCycleScheduleByDate(companyId: number, date?: string) {
  let params = new HttpParams()
    .set('CompanyId', companyId.toString());

  if (date) {
    params = params.set('Date', date);
  }

  return this.http.get<ColorSchedule>(
    `${this.baseUrl}/ByDate`,
    { params }
  );
}
}
